(() => {
  const sections = document.querySelectorAll('[data-calinfi-collection-products]');

  sections.forEach((section) => {
    const scroller = section.querySelector('[data-calinfi-slider]');
    const progress = section.querySelector('[data-calinfi-progress]');
    const prev = section.querySelector('[data-calinfi-prev]');
    const next = section.querySelector('[data-calinfi-next]');

    if (!scroller) return;

    const getStep = () => {
      const item = scroller.querySelector('.calinfi-collection-products__item');
      if (!item) return scroller.clientWidth * 0.8;

      const styles = window.getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return item.getBoundingClientRect().width + gap;
    };

    const updateProgress = () => {
      if (!progress) return;

      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 0) {
        progress.style.width = '100%';
        return;
      }

      const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
      const scrollRatio = scroller.scrollLeft / maxScroll;
      const width = Math.max(visibleRatio * 100, 6);
      const left = scrollRatio * (100 - width);

      progress.style.width = `${width}%`;
      progress.style.left = `${left}%`;
    };

    prev?.addEventListener('click', () => {
      scroller.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      scroller.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  });
})();
